import React, { Component } from 'react';

//Templates
import Atoms from '../../components/templates/Atoms';
import Molecules from '../../components/templates/Molecules';
import Organisms from '../../components/templates/Organisms';
import TemplateSignUp from '../../components/templates/SignUp';
import TemplateLogin from '../../components/templates/Login';
import TemplatePasswordReset from '../../components/templates/PasswordReset';
import DashboardSubjects from '../../components/templates/DashboardSubjects';
import DashboardConversation from '../../components/templates/DashboardConversation';
import DashboardAccount from '../../components/templates/DashboardAccount';
import DashboardBilling from '../../components/templates/DashboardBilling';
import DashboardSubscription from '../../components/templates/DashboardSubscription';
import DashboardInvoice from '../../components/templates/DashboardInvoice';




//Pages
import Verify from '../../components/pages/Verify/VerifyContainer';
import Frontpage from '../../components/pages/Frontpage/Frontpage';

import Login from '../../components/pages/Login/Login';
import PasswordReset from '../../components/pages/PasswordReset/PasswordReset';
import SignUp from '../../components/pages/SignUp/SignUpContainer';
import TermsOfUse from '../../components/pages/Legal/TermsOfUse';
import PrivacyPolicy from '../../components/pages/Legal/PrivacyPolicy';

// PrivateRoute
import { BrowserRouter as Router, Route } from 'react-router-dom';
import BotsRoutes from './bots-router';
// import { data } from './defaultData.js';
import './style.css';

class Routes extends Component {
	constructor(props) {
		super(props);

		this.renderHandler = this.renderHandler.bind(this);
		this.renderDevelopment = this.renderDevelopment.bind(this);
		this.renderProduction = this.renderProduction.bind(this);
	}
	renderDevelopment() {
		return (
			<Router>
				<div>
					{/* Templates */}
					<Route exact path="/" component={Frontpage}/>
					<Route path="/atoms" component={Atoms}/>
					<Route path="/molecules" component={Molecules}/>
					<Route path="/organisms" component={Organisms}/>
					<Route path="/templatesignup" component={TemplateSignUp}/>
					<Route path="/templatelogin" component={TemplateLogin}/>
					<Route path="/templatepasswordreset" component={TemplatePasswordReset}/>
					<Route path="/DashboardSubjects" component={DashboardSubjects}/>
					<Route path="/DashboardConversation" component={DashboardConversation}/>
					<Route path="/DashboardAccount" component={DashboardAccount}/>
					<Route path="/DashboardBilling" component={DashboardBilling}/>
					<Route path="/DashboardSubscription" component={DashboardSubscription}/>
					<Route path="/DashboardInvoice" component={DashboardInvoice}/>
	

		

					{/* Pages */}	
					<Route path="/login" component={Login}/>
					<Route path="/passwordreset" component={PasswordReset}/>
					<Route path="/signup" component={SignUp}/>
					<Route path="/bots" component={BotsRoutes}/>
					<Route path="/verify" component={Verify}/>
					<Route path="/terms-of-use" component={TermsOfUse}/>
					<Route path="/privacy-policy" component={PrivacyPolicy}/>
				</div>
			</Router>
		)
	}
	renderProduction() {
		return (
			<Router>
				<div>
					{/* Pages */}
					<Route exact path="/" component={Frontpage}/>
					<Route path="/login" component={Login}/>
					<Route path="/signup" component={SignUp}/>
					<Route path="/bots" component={BotsRoutes}/>
					<Route path="/verify" component={Verify}/>
					<Route path="/terms-of-use" component={TermsOfUse}/>
					<Route path="/privacy-policy" component={PrivacyPolicy}/>
				</div>
			</Router>
		)
	}
	renderHandler() {
		return process.env.NODE_ENV === "production" ? this.renderProduction() : this.renderDevelopment()
	}
  render() {
    return (
			this.renderHandler()
    )
  }
}

export default Routes;


// WEBPACK FOOTER //
// ./src/redux/config/Routes/Routes.jsx